/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandTumblr = createReactComponent("brand-tumblr", "IconBrandTumblr", [
  [
    "path",
    {
      d: "M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4",
      key: "svg-0"
    }
  ]
]);

export { IconBrandTumblr as default };
//# sourceMappingURL=IconBrandTumblr.js.map
